export default __webpack_public_path__ + "images/65d36063e94391839049f60ea2399574.png";